import { Model, SortedCollection, Requests } from '@nichoth/observ'

// sort fns
var sorts = {
    name: function name (asset) {
        return asset.name.toLowerCase()
    },
    dateCreated: 'dateCreated'
}

function MiscAssetsModel ({ io }) {
    var State = SortedCollection({
        order: 'desc',
        sortBy: sorts.dateCreated,
        indexBy: 'assetID'
    })

    var miscAssetsModel = Model({
        io,
        state: { data: State() },
        update: {
            get: function (state, res) {
                state.hasFetched.set(true)
                State.get(state.data, res.data)
            },

            edit: function (state, res) {
                State.edit(state.data, res.data)
            },
            editLink: function (state, res) {
                State.editLink(state.data, res.data)
            },

            delete: function (state, res) {
                if (!state.data.indexed()[res.data.assetID]) return
                State.delete(state.data, res.data)
            },

            getPlaceholder: function (state, res) {
                // console.log('placeholder', res)
                State.add(state.data, res.data)
            },

            // sync methods
            sortBy: function (state, sort) {
                State.sortBy(state.data, sorts[sort])
            },
            orderBy: (state, order) => State.orderBy(state.data, order),

            editSync: function (state, asset) {
                if (!state.data.indexed()[asset.assetID]) return
                State.edit(state.data, asset)
            },

            addSync: function (state, asset) {
                State.add(state.data, asset)
            },

            deleteSync: function (state, asset) {
                if (!state.data.indexed()[asset.assetID]) return
                State.delete(state.data, asset)
            },

            clearError: function (state) {
                Requests.clearError(state.requests)
            }
        }
    })

    return miscAssetsModel
}

function createIo ({ publicApi, crudApi }) {
    var io = {
        get: publicApi('/Assets/getMiscAssets'),
        edit: crudApi('/asset/update'),
        editLink: crudApi('/asset/updateLinkedAsset'),
        delete: crudApi('/asset/delete'),
        getPlaceholder: crudApi('/upload/newUpload')
    }
    return io
}

function createModels ({ io }) {
    var models = {
        assets: MiscAssetsModel({ io })
    }
    return models
}

createModels.createIo = createIo

export default createModels




/*
get placeholder response

{
  "errors": {
    "hasError": false,
    "message": null
  },
  "data": {
    "assetID": "a23f4dec48e588eabd66cdb160bfa687675615d3",
    "clientID": "1000000000",
    "eventID": "0",
    "name": "file upload SampleVideo_1280x720_10mb.mp4",
    "type": "upload",
    "dateCreated": "2018-12-17 19:34:53",
    "fileSize": "10498677",
    "totalRunTime": null,
    "totalRunTimeS": null,
    "currentStatus": "processing upload",
    "fileUrl": null,
    "thumbnail": "",
    "sprite": null,
    "liveID": null,
    "recStartDate": null,
    "recStopDate": null,
    "estRecDur": null,
    "path": null,
    "TTL": "2018-12-27 19:34:53",
    "advancedDetails": false,
    "previewURI": null
  },
  "meta": []
}

*/